<div class="partner-capital-main-container">
  <div class="partner-capital-container">
    <!-- Header Section -->
    <div class="partner-capital-header">
      <!-- Refresh -->
      <div class="refresh-btn">
        <!-- <button title="Refresh" class="stroked-btn transparent-btn" (click)="refresh()">
            <i class="fa-regular fa-arrows-rotate tbh-act-ico"></i>
        </button> -->
      </div>
      <!-- Title -->
      <ng-container *ngIf="isSettingsEnabled">
        <div class="header">
          <h3>Statement of Partners Capital</h3>
        </div>
      </ng-container>

      <ng-container *ngIf="!isSettingsEnabled">
        <div class="header">
          <h3>Statement of Partners Capital Settings</h3>
        </div>
      </ng-container>


      <!-- Expansion Panels -->
      <div class="settings-btn">
        <ng-container *ngIf="isSettingsEnabled">
          <!-- Vertical  -->
          <ng-container *ngIf="isHorizontal">
            <button style="width: 28px;" class="transparent-btn mar-r-8" (click)="expandPanles('horizontalPanel')"
                    [attr.title]="isExpandedHorizantalPanels ? 'Expand All' : 'Collapse All'">
                <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" *ngIf="isExpandedHorizantalPanels"></i>
                <i class="fa-light fa-arrow-down-left-and-arrow-up-right-to-center" *ngIf="!isExpandedHorizantalPanels"></i>
            </button>
          </ng-container>
          <!-- Vertical  -->
          <ng-container *ngIf="isVertical">
            <button style="width: 28px;" class="transparent-btn mar-r-8" (click)="expandPanles('verticalPanel')"
                    [attr.title]="isExpandedVerticalPanels ? 'Expand All' : 'Collapse All'">
                <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" *ngIf="isExpandedVerticalPanels"></i>
                <i class="fa-light fa-arrow-down-left-and-arrow-up-right-to-center" *ngIf="!isExpandedVerticalPanels"></i>
            </button>
          </ng-container>

        </ng-container>

        <button title="Settings" class="transparent-btn mar-r-24" [disabled]="drawerStatus" (click)="setPartnersCapital()">
            <i class="fa-regular fa-sliders tbh-act-ico"></i>
        </button>
      </div>

    </div>
    <ng-container *ngIf="isSettingsEnabled">
      <div class="partner-capital-views-header">
        <div class="float-left">
          <mat-radio-group class="radiogroup">
            <mat-radio-button value="0" name="viewName" (change)="updateView($event.value)"
                              [checked]="isHorizontal ? true : false">Horizontal</mat-radio-button>
            <mat-radio-button value="1" name="viewName" (change)="updateView($event.value)"
                              [checked]="isVertical ? true : false">Vertical</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </ng-container>
    <!-- Main Content -->
    <div class="partner-capital-body">

      <ng-container *ngIf="isSettingsEnabled; else veiwEnabled">
        <!-- Partner Capital Horizontal View-->
        <ng-container *ngIf="isHorizontal">
          <app-partner-capital-horizontal [horozontalPanelsState]="isExpandedHorizantalPanels"></app-partner-capital-horizontal>
        </ng-container>
        <!-- Partner Capital Vertical View-->
        <ng-container *ngIf="isVertical">
          <app-partner-capital-vertical [verticalPanelsState]="isExpandedVerticalPanels"></app-partner-capital-vertical>
        </ng-container>
      </ng-container>

      <!-- Partner Capitals Settings -->
      <ng-template #veiwEnabled>
        <app-partner-capital-settings></app-partner-capital-settings>
      </ng-template>

    </div>
  </div>
  <!-- Right Side Panel Preview -->
  <div class="partner-capital-aside">
    <div class="partner-capital-aside-header">
      <div class="refresh-btn-preview">
        <!-- <button title="Refresh" class="stroked-btn transparent-btn">
            <i class="fa-regular fa-arrows-rotate tbh-act-ico"></i>
        </button> -->
      </div>
      <div class="partner-capital-aside-header-content">
        <h3>Preview</h3>
      </div>
      <div class="empty-div"></div>
    </div>
    <div class="partner-capital-aside-body">
      <ng-container *ngIf="isHorizontal || isVertical">
        <app-partner-capital-preview [isEnabledHorizantal]="isHorizontal"
        [isEnabledVertical]="isVertical"></app-partner-capital-preview>
      </ng-container>
    </div>
  </div>
</div>
